import { motion } from "framer-motion";
import { ArrowUpRight, Instagram, Phone } from "lucide-react";

export const Contact = () => (
  <section
    id="contact"
    data-testid="contact-section"
    className="border-t border-white/10 bg-[#050505] px-5 py-24 sm:px-10 sm:py-36"
  >
    <div className="mx-auto max-w-7xl">
      <motion.span
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        className="mb-8 block font-mono text-[10px] uppercase tracking-[0.35em] text-[#8E8E93] sm:text-xs"
      >
        08 — START A PROJECT
      </motion.span>

      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="font-display text-[clamp(2.8rem,8vw,7.5rem)] font-black uppercase leading-[0.9] tracking-tight text-[#F3F3F5]"
      >
        YOUR CAMERA ROLL HAS A STORY IN IT.{" "}
        <span className="text-[#E63946]">LET'S EDIT IT.</span>
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.15 }}
        className="mt-10 max-w-xl text-sm leading-relaxed text-[#8E8E93] sm:text-base"
      >
        Want a video done? Reach me directly — tell me what you filmed and what you want it to
        feel like, and we'll take it from there.
      </motion.p>

      <div className="mt-14 grid grid-cols-1 gap-px border border-white/10 bg-white/10 md:grid-cols-2">
        <motion.a
          data-testid="contact-phone-link"
          href="tel:+17323378268"
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="group relative bg-[#050505] p-8 transition-colors duration-500 hover:bg-[#121215] sm:p-12"
        >
          <div className="flex items-start justify-between">
            <span className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.35em] text-[#8E8E93] sm:text-xs">
              <Phone className="h-4 w-4 text-[#E63946]" strokeWidth={1.5} />
              CALL OR TEXT
            </span>
            <ArrowUpRight
              className="h-5 w-5 text-[#8E8E93] transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#E63946]"
              strokeWidth={1.5}
            />
          </div>
          <span className="mt-10 block font-display text-4xl font-black uppercase leading-none tracking-tight text-[#F3F3F5] transition-colors duration-500 group-hover:text-white sm:mt-14 sm:text-6xl">
            (732) 337-8268
          </span>
          <span className="mt-5 block text-sm text-[#8E8E93]">
            Fastest way to reach me — text works great.
          </span>
        </motion.a>

        <motion.a
          data-testid="contact-instagram-link"
          href="https://www.instagram.com/j.erem1ah/"
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: 0.08, ease: [0.16, 1, 0.3, 1] }}
          className="group relative bg-[#050505] p-8 transition-colors duration-500 hover:bg-[#121215] sm:p-12"
        >
          <div className="flex items-start justify-between">
            <span className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.35em] text-[#8E8E93] sm:text-xs">
              <Instagram className="h-4 w-4 text-[#E63946]" strokeWidth={1.5} />
              INSTAGRAM
            </span>
            <ArrowUpRight
              className="h-5 w-5 text-[#8E8E93] transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#E63946]"
              strokeWidth={1.5}
            />
          </div>
          <span className="mt-10 block font-display text-4xl font-black uppercase leading-none tracking-tight text-[#F3F3F5] transition-colors duration-500 group-hover:text-white sm:mt-14 sm:text-6xl">
            @J.EREM1AH
          </span>
          <span className="mt-5 block text-sm text-[#8E8E93]">
            DM me your footage ideas — demos sent straight to your messages.
          </span>
        </motion.a>
      </div>

      <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.3em] text-[#3a3a3f]">
        RESPONSE WITHIN 24–48 HOURS — PHONE FOOTAGE WELCOME
      </p>
    </div>
  </section>
);
